import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectPartnerHasMemberCode = createSelector(
  (state: GlobalState) => state.partnerStatus,
  (partnerStatus) => partnerStatus.hasMemberCode,
);

export const selectPartnerId = createSelector(
  (state: GlobalState) => state.partnerStatus,
  (partnerStatus) => partnerStatus.partnerId,
);

export const selectPartnerStatusError = createSelector(
  (state: GlobalState) => state.partnerStatus,
  (partnerStatus) => partnerStatus.customError,
);

export const selectIsEligible = createSelector(
  (state: GlobalState) => state.partnerStatus,
  (partnerStatus) => partnerStatus.eligibility,
);
